import { createBrowserRouter, Navigate } from "react-router";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { AdminRoute } from "../components/AdminRoute";
import { LoginPage } from "./LoginPage";
import { DashboardPage } from "./DashboardPage";
import { ExperimentPage } from "./ExperimentPage";
import { SetPasswordPage } from "./SetPasswordPage";
import { AdminTeachersPage } from "./admin/AdminTeachersPage";
import { AdminLayout } from "./admin/AdminLayout";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/set-password",
    element: <SetPasswordPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/play/:slug",
        element: <ExperimentPage />,
      },
      {
        path: "/admin",
        element: <AdminRoute />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              {
                path: "teachers",
                element: <AdminTeachersPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
]);
